import { Cloudinary } from '@cloudinary/url-gen'
import { fill, crop, scale, fit } from '@cloudinary/url-gen/actions/resize';

const cloudName = 'trip-to-go'

export function useCloudinary() {
  const cloudinary = new Cloudinary({
    cloud: {
      cloudName: cloudName
    },
    url: {
      secure: true
    }
  })

  return { cloudinary }
}

export function useCloudinaryImageUrl(
  publicId: string, 
  options: { width?: number; height?: number; resize?: string; quality?: string } = {}
) {
  const { cloudinary } = useCloudinary()

  const width = options.width || 800
  const height = options.height || 533  
  const resizeType = options.resize || 'fill'
  const quality = options.quality || 'auto:best'
  
  const image = cloudinary.image(publicId)
  image.format('auto')
  image.quality(quality)

  if (resizeType === 'fill') {
    image.resize(fill().width(width).height(height))
  } else if (resizeType === 'scale') {
    image.resize(scale().width(width).height(height))
  } else if (resizeType === 'crop') {
    image.resize(crop().width(width).height(height))
  } else if (resizeType === 'fit') {
    image.resize(fit().width(width).height(height))
  }

  return image.toURL()
}
